import React, { useState } from 'react';
import './InvoiceAdvancedFilter.css';

const InvoiceAdvancedFilter = ({ isOpen, onClose, onApply, onClear }) => {
    const [applyLogic, setApplyLogic] = useState('AND');
    const [searchRows, setSearchRows] = useState([
        { id: Date.now(), field: '', operator: 'contains', value: '' }
    ]);

    const fields = [
        { value: 'InvoiceNumber', label: 'Invoice Number' },
        { value: 'CustomerName', label: 'Customer Name' },
        { value: 'EmailID', label: 'Customer Email' },
        { value: 'MobileNo', label: 'Customer Phone' },
        { value: 'ContactTaxNumber', label: 'Tax Number' },
        { value: 'TotalAmount', label: 'Amount' },
        { value: 'LeadId', label: 'Lead ID' },
        { value: 'InvoiceDate', label: 'Invoice Date' },
        { value: 'ExpiryDate', label: 'Valid Till' },
        { value: 'Status', label: 'Status' },
        { value: 'CreatedOn', label: 'Created On' },
        { value: 'CreatedBy', label: 'Created By' }
    ];

    const operators = [
        { value: 'contains', label: 'contains' },
        { value: 'does_not_contain', label: 'does not contain' },
        { value: 'begins_with', label: 'begins with' },
        { value: 'ends_with', label: 'ends with' },
        { value: 'does_not_begin_with', label: 'does not begin with' },
        { value: 'does_not_end_with', label: 'does not end with' },
        { value: 'equal_to', label: 'equal to' },
        { value: 'not_equal_to', label: 'not equal to' }
    ];

    const addRow = () => {
        setSearchRows([...searchRows, { id: Date.now(), field: '', operator: 'contains', value: '' }]);
    };

    const removeRow = (id) => {
        if (searchRows.length > 1) {
            setSearchRows(searchRows.filter(row => row.id !== id));
        }
    };

    const updateRow = (id, key, val) => {
        setSearchRows(searchRows.map(row => row.id === id ? { ...row, [key]: val } : row));
    };

    const handleSubmit = () => {
        const activeRows = searchRows.filter(r => r.field && r.value.trim());
        onApply({ logic: applyLogic, rows: activeRows });
        onClose();
    };

    const handleClear = () => {
        setApplyLogic('AND');
        setSearchRows([{ id: Date.now(), field: '', operator: 'contains', value: '' }]);
        onClear();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="invoice-filter-overlay" onClick={onClose}>
            <div className="invoice-filter-panel" onClick={e => e.stopPropagation()}>
                <div className="invoice-filter-header">
                    <h3>Advance Filters</h3>
                    <button className="invoice-filter-close" onClick={onClose}>&times;</button>
                </div>

                <div className="invoice-filter-body">
                    <div className="filter-logic-section">
                        <div className="logic-toggle">
                            <label>
                                <input
                                    type="radio"
                                    name="logic"
                                    value="AND"
                                    checked={applyLogic === 'AND'}
                                    onChange={() => setApplyLogic('AND')}
                                />
                                All Invoices (AND)
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="logic"
                                    value="OR"
                                    checked={applyLogic === 'OR'}
                                    onChange={() => setApplyLogic('OR')}
                                />
                                Any Invoice (OR)
                            </label>
                        </div>
                    </div>

                    <div className="filter-rows-container">
                        {searchRows.map((row, idx) => (
                            <div key={row.id} className="filter-search-row">
                                <select
                                    className="filter-control filter-field-select"
                                    value={row.field}
                                    onChange={e => updateRow(row.id, 'field', e.target.value)}
                                >
                                    <option value="">--- Select Field ---</option>
                                    {fields.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                                </select>

                                <select
                                    className="filter-control filter-op-select"
                                    value={row.operator}
                                    onChange={e => updateRow(row.id, 'operator', e.target.value)}
                                >
                                    <option value="">-- Select Operator --</option>
                                    {operators.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                </select>

                                <input
                                    type="text"
                                    className="filter-control filter-value-input"
                                    placeholder="Search value"
                                    value={row.value}
                                    onChange={e => updateRow(row.id, 'value', e.target.value)}
                                />

                                <div className="filter-row-actions">
                                    {idx === searchRows.length - 1 ? (
                                        <button className="add-filter-row-btn" onClick={addRow} title="Add Row">+</button>
                                    ) : (
                                        <button className="remove-filter-row-btn" onClick={() => removeRow(row.id)} title="Remove Row">−</button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="invoice-filter-footer">
                    <button className="btn-clear-filters" onClick={handleClear}>Clear All</button>
                    <div className="filter-footer-right">
                        <button className="btn-cancel-filter" onClick={onClose}>Cancel</button>
                        <button className="btn-submit-filter" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceAdvancedFilter;
